import React from 'react';
import PropTypes from 'prop-types';

function VideoIframe({
  src,
}) {
  return (
    <>
      <a href="#" className="btn-play">
        <span className="visually-hidden">play video</span>
      </a>
      <iframe width="560" height="315" className="z-4" loading="lazy" data-src={src} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
    </>
  );
}

VideoIframe.propTypes = {
  src: PropTypes.string.isRequired,
};

export { VideoIframe };
